import { getPageImage } from "@/lib/page-imagery";
const industriesHero = getPageImage("/industries");
import { EditorialHero } from "./EditorialHero";
import { LangLink } from "./LangLink";
import { BuyerGuides, ResponsibilityNote } from "./BuyerGuides";
import { industries } from "@/lib/industries";
import { useLanguage } from "@/lib/language";
export function IndustriesContent() {
  const { t } = useLanguage();
  return (
    <>
      <EditorialHero image={industriesHero.src} alt={t(industriesHero.alt)}>
        <p className="ic-eyebrow">
          {t({ en: "Your activity sets the scope", ar: "نشاط شركتك يحدد النطاق" })}
        </p>
        <h1 className="ic-title">
          {t({ en: "Management systems for your sector.", ar: "أنظمة إدارة تناسب قطاعك." })}
        </h1>
        <p className="ic-intro">
          {t({
            en: "Use these guides to compare relevant standards and review practical questions. Your activities, sites and buyer’s conditions determine what you need.",
            ar: "استخدم هذه الأدلة لمقارنة المواصفات ذات الصلة ومراجعة الأسئلة العملية. تحدد أنشطتك ومواقعك وشروط الجهة المشترية ما تحتاجه فعلياً.",
          })}
        </p>
        <LangLink to="/insights/which-iso-standard-does-my-company-need" className="ic-button mt-7">
          {t({ en: "Choose a standard for your activity", ar: "اختر المواصفة المناسبة لنشاطك" })}
        </LangLink>
      </EditorialHero>
      <section id="sector-guides" className="ic-section">
        <div className="ic-section-heading">
          <h2>{t({ en: "Explore by company activity", ar: "استعرض القطاعات بحسب نشاط شركتك" })}</h2>
          <p>
            {t({
              en: "A sector is a starting point, not a fixed package of certificates. Read the activity-specific guidance before choosing a standard.",
              ar: "القطاع نقطة بداية، وليس باقة ثابتة من الشهادات. اقرأ الإرشادات المرتبطة بنشاطك قبل اختيار المواصفة.",
            })}
          </p>
        </div>
        <div className="ic-service-grid">
          {industries.map((ind) => (
            <LangLink key={ind.slug} to={`/industries/${ind.slug}`} className="ic-service-card">
              <h3>{t(ind.name)}</h3>
              <p className="ic-small">
                <bdi dir="ltr">{ind.standards.join(" · ")}</bdi>
              </p>
              <span className="ic-text-link">
                {t({ en: "Read sector guidance", ar: "اقرأ إرشادات القطاع" })}
              </span>
            </LangLink>
          ))}
        </div>
      </section>
      <ResponsibilityNote />
      <BuyerGuides />
      <section className="ic-surface">
        <div className="ic-section ic-closing">
          <div>
            <h2>
              {t({
                en: "Let’s define the work around your business.",
                ar: "لنحدد العمل بحسب احتياجات شركتك.",
              })}
            </h2>
            <p>
              {t({
                en: "Start with your activity, locations and customer requirement.",
                ar: "ابدأ بنشاط الشركة ومواقعها ومتطلب العميل.",
              })}
            </p>
          </div>
          <LangLink to="/contact" className="ic-button">
            {t({ en: "Discuss your requirement", ar: "ناقش متطلبك" })}
          </LangLink>
        </div>
      </section>
    </>
  );
}
